<template>
    <div :class="[
        'operate__header position--relative display--flex',
        isNotInterceptCall ? 'operate__header--space' : 'operate__header--center'
    ]">
        <div class="operate__header__timer">
            <timer
                v-if="showTimer"
                class="operate__header__timer__element"
                :intervalBetweenCalls="timeBetweenCalls"
                :settings="{ loadLargeCounter: false, width: 45, height: 45 }"
                :action="submitForm"
            />
        </div>
        <call-controlls v-bind="{ callIsActive, callHasBeenConfirmed, callNumber, isOnHold, disableRecording, blockTypification }"/>
        <typification-actions v-if="isNotInterceptCall" :workflow="workflow" />
    </div>
</template>

<script>
// package
import { computed } from '@vue/composition-api';

// store
// import { useActions } from '@/hooks/use-store';

export default {
    components: {
        Timer: () => import( /* webpackChunkName: 'Timer' */ '@/components/bundles/operate/blocks/Timer' ),
        CallControlls: () => import( /* webpackChunkName: 'CallControlls' */ '@/components/bundles/operate/blocks/header/CallControlls' ),
        TypificationActions: () => import(
            /* webpackChunkName: 'TypificationActions' */ '@/components/bundles/operate/blocks/header/TypificationActions'
        )
    },
    props: {
        showTimer: Boolean,
        timeBetweenCalls: {
            type: Number,
            default: 10
        },
        callIsActive: Boolean,
        callHasBeenConfirmed: Boolean,
        callNumber: String,
        isOnHold: Boolean,
        disableRecording: Boolean,
        blockTypification: Boolean,
        workflow: String
    },
    setup ( props, { emit }) {
        const submitForm = () => {
            emit( 'trigger-new-request' );
            /*
            TODO: submissão para APi, mas falta o estado.
            const { actions } = useActions();
            actions( 'submit', { typeOfPreparation: 'call' }); */
        };

        const isNotInterceptCall = computed( () => props.workflow !== 'intercept' );

        return { isNotInterceptCall, submitForm };
    }
};
</script>

<style lang="scss">
    .operate {
        &__header {
            width: 100%;
            margin: 0 0 36px;
            &--space {
                @include position-grid( flex-start, space-between );
            }
            &--center {
                justify-content: center;
                margin-left: -80px;
            }
            &__timer {
                width: 55px;
                &__element {
                    padding-top: 10px;
                }
            }
        }
    }
</style>